import { Component, Snackbar, SnackbarOptions, Table } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { DesignerDataSource } from "../DesignerDataSource";
import { ActionDeleteTableComponent } from "./ActionDeleteTableComponent";
import { DesignerAction } from "./DesignerAction";
import { DesignerActionResult } from "./DesignerActionResult";

export class ActionDeleteComponent implements DesignerAction {
    component: Component;
    index: number;
    specialDeleteAction: DesignerAction;

    constructor(component) {
        this.component = component;
    }

    execute(): DesignerActionResult {
        if (this.component.deletableInDesigner !== true) {
            const snackbarMessage = "Deletion of component " + this.component.id + " is not allowed.";
            const snackbarOptions: SnackbarOptions = { id: "no-delete-" + this.component.id };
            Snackbar.showWarningSnackbar(snackbarMessage, snackbarOptions);
            return;
        }
        if (this.component.parent instanceof Table) {
            const deleteAction = new ActionDeleteTableComponent(this.component, this.component.parent);
            const result = deleteAction.execute()
            if (result != null) {
                this.specialDeleteAction = deleteAction;
                return result;
            }
        }
        this.index = this.component.parent.indexOf(this.component);
        this.component.parent.remove(this.component);

        if (this.component instanceof DesignerDataSource) {
            const tab = this.component._designer.getActiveTab();
            if (tab.dataSources) {
                delete tab.dataSources[this.component.designerDataSource.id];
            }
        }
        this.component._designer.selectComponent(null);
        return { success: true };
    }

    undo() {
        if (this.specialDeleteAction?.undo != null) {
            this.specialDeleteAction?.undo();
        } else {
            this.component.parent.insert(this.component, this.index);
            this.component._designer.selectComponent(this.component);
        }
    }

    toString() {
        if (this.specialDeleteAction)
            return this.specialDeleteAction.toString();
        return `Delete ${StringUtil.toProperCase(this.component.serializationName)} - ${this.component.id}`;
    }
}
